<template >
  <li role="presentation">
    <div class="child flex items-center ml-12 pl-4 mr-2 group link-name group-parent-bold ml-1 border-solid rounded mt-1"
      :class="{'color-link-disabled': item.warning === 2}"
      >
        <span 
          class="pt-[0.35rem] pb-[0.35rem]"
          @keydown.esc="tooltipVisible = false"
          @mouseenter="tooltipVisible = true"
          @mouseleave="tooltipVisible = false"
          @focus="tooltipVisible = true"
          @blur="tooltipVisible = false"
          >
          {{ title }}
          <span v-if="item.warning === 3" class="k-icon k-i-warning color-warning ml-1 pr-1"/>
        </span>
      <span
      @click.prevent="toggleGroup"
      class="arrow ml-auto w-8 h-7 flex-none flex items-center justify-center cursor-pointer hover:bg-primary-200 dark:hover:bg-darkblue-600  rounded animate-hover"
      >
        <button
          :class="{ 'rotate-180': activeGroup }"
          class="flex-shrink-0 px-2 transform transition-transform duration-300 dark:text-darkblue-400 dark:hover:text-primary"
          :aria-expanded="activeGroup ? 'true' : 'false'"
          aria-haspopup="true"
          :aria-controls="'submenu-group-' + item.name"
          :aria-label="'Alternar submenú de grupo ' + title"
          tabindex="0"
        >
          <base-icon 
            name="chevrondown" 
            size="sm" 
            :title="activeGroup ? 'Contraer submenú' : 'Desplegar submenú'" 
            />
        </button>
      </span>
    </div>
      <transition
        name="list-links"
        @enter="startTransition"
        @after-enter="endTransition"
        @before-leave="startTransition"
        @after-leave="endTransition"
      >
        <ol v-show="activeGroup" 
            class="relative group-container">
          <base-aside-nav-item-link 
            v-for="link in item.sc" :key="link.name"  
            :link="link"
            />
        </ol>
      </transition>
  </li>
</template>

<script>
import { bus } from '@/main'

export default {
  name: 'aside-nav-item-group',
  props: {
    item: {
      type: [Object, Array],
      required: true
    },
    title: {
      type: String,
      default: 'Cabecera'
    }
  },
  data: function () {
    return {
      activeGroup: true,
      tooltipVisible: false,
    }
  },
  mounted () {
    if (this.item?.desplegado === false) {
      this.activeGroup = false
    }
  },
  computed: {
    isLower1024 () {
      return this.$store.getters['app/getIsLower1024']
    }
  },
  watch: {
    tooltipVisible (visible) {
      if (visible) {
        document.addEventListener('keydown', this.onKeydown)
        bus.$emit('asideTooltipVisibility', true)
      } else {
        document.removeEventListener('keydown', this.onKeydown)
        bus.$emit('asideTooltipVisibility', false)
      }
    }
  },
  beforeDestroy () {
    document.removeEventListener('keydown', this.onKeydown)
    if (this.tooltipVisible) bus.$emit('asideTooltipVisibility', false)
  },
  methods: {
    toggleGroup: function () {
      this.activeGroup = !this.activeGroup
    },
    startTransition: function (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    endTransition: function (el) {
      el.style.height = ''
    },
    onKeydown (event) {
      if (event.key === 'Escape') {
        this.tooltipVisible = false
      }
    }
  }
}
</script>

<style lang="scss" scoped>
a.parent {
  @apply pl-4 pr-5;
}
[data-type='main'] {
  a.parent {
    @apply pl-3 pr-1;
  }
}
a.child {
  @apply pl-12;
}
.group-container{
  @apply bg-primary-50;
  @apply dark:bg-darkblue;
}
[data-type='main'] {
  a.child {
    @apply pl-11;
  }
  div.child {
    @apply pl-4;
    @apply ml-8;
  }
  .group-container{
    @apply bg-white;
    @apply dark:bg-darkblue-900;
  }
}

.animate-hover {
  @apply transition-colors duration-300;
}
.animate-all {
  @apply transition-all duration-300;
}
.cover-subnav {
  @apply border-secondary-100;
}
.span-nav-link-container{
  @apply border-secondary-200;
}
.link-icon {
  @apply text-secondary-500 dark:text-darkblue-400;
}
.link-name {
    @apply text-secondary-800 dark:text-darkblue-200 font-medium;
  }
.link-name.color-link-disabled{
  @apply text-secondary-600;
}
.dark .link-name.color-link-disabled{
  @apply text-secondary-300;
}
.router-link-active {
  .link-icon {
    @apply text-secondary dark:text-darkblue-200;
  }
  .link-name {
    @apply text-secondary-800 dark:text-darkblue-100 font-bold;
  }
  .color-link-disabled{
    @apply text-secondary-800;
  }
  .cover-subnav {
    @apply border-primary;
  }
  .span-nav-link-container{
    @apply border-primary;
  }
}
.rotate-180 {
  transform: rotate(-180deg);
}
.list-links-enter-active,
.list-links-leave-active {
  will-change: height;
  transition: height 0.2s ease-out;
}
.list-links-enter,
.list-links-leave-to {
  height: 0 !important;
}
</style>
